// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--M2OM8{0%{background-position:200% 0}100%{background-position:-200% 0}}.contact-button--w55U_.lumen5-button.btn{border-color:#000;background-color:#fff;color:#000}.contact-button--w55U_.lumen5-button.btn:hover{border-color:#000;background-color:#000;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact-button": "contact-button--w55U_",
	"shimmer-loading": "shimmer-loading--M2OM8"
};
export default ___CSS_LOADER_EXPORT___;
